import iconsPng from '@/assets/img/png/icons';
import CustomButton from '@/components/atoms/CustomButton';
import LoadingPage from '@/components/templates/LoadingPage';
import useValidateOrg from '@/hooks/publicscreener/useValidateOrg';
import { Image, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

type Props = {
  organizationSlug: string;
  isValid: boolean;
  setIsValid: Dispatch<SetStateAction<boolean>>;
};

const TryScreenerOrganizationValidation = ({ organizationSlug, setIsValid, isValid }: Props) => {
  const navigate = useNavigate();

  const { data, isLoading, isSuccess } = useValidateOrg(organizationSlug);

  useEffect(() => {
    if (data && isSuccess) {
      const isOrgSlugValid = !!data?.valid;
      setIsValid(isOrgSlugValid);
    }
  }, [data, isSuccess, isLoading]);

  return (
    <VStack>
      {isLoading && <LoadingPage position="fixed" />}
      {!isLoading && isSuccess && !isValid && (
        <VStack marginTop={'16px'}>
          <Image alt="ok-hand" src={iconsPng.heartInHand} width={120} height={120} />
          <Text variant={'loraExtraSmallTitle'} color={'text.mediumBlue'} mb={'10px'}>
            Oooops...
          </Text>
          <Text variant={'urbanistSemiBold'} mb={'10px'}>
            Looks like the organization slug in url is not valid or expired.
          </Text>
          <CustomButton
            label="Create your own organization"
            backgroundColor="primary.500"
            labelColor="extra.white"
            buttonType="submit"
            onClick={() => {
              navigate({ to: '/try-screener' });
            }}
          />
        </VStack>
      )}
    </VStack>
  );
};

export default TryScreenerOrganizationValidation;
